'use strict'

class MainController {
  constructor (
    authService,
    $sessionStorage,
    $http,
    agendaService,
    certificateService,
    paymentService,
    formService,
    companyService,
    tablePriceService,
    $moment,
    $scope,
    $window,
    $uibModal,
    $location,
    STATES,
    THEME_PRIMARY_COLOR,
    THEME_SECUNDARY_COLOR,
    CARD_SECRET
  ) {
    this.authService = authService
    this.$sessionStorage = $sessionStorage
    this.$http = $http
    this.agendaService = agendaService
    this.certificateService = certificateService
    this.paymentService = paymentService
    this.formService = formService
    this.companyService = companyService
    this.tablePriceService = tablePriceService
    this.$moment = $moment
    this.$scope = $scope
    this.$window = $window
    this.$uibModal = $uibModal
    this.$location = $location
    this.STATES = STATES
    this.THEME_PRIMARY_COLOR = THEME_PRIMARY_COLOR
    this.THEME_SECUNDARY_COLOR = THEME_SECUNDARY_COLOR
    this.CARD_SECRET = CARD_SECRET

    this.DIC_TYPE = {
      cpf: 'e-CPF',
      cnpj: 'e-CNPJ',
      'e-SIMPLES': 'e-Simples',
      CPF_PLUS: 'CPF PLUS',
      'e-JURIDICO': 'e-Jurídico',
      'e-SAUDE': 'e-Saúde'
    }
    this.DIC_MEDIA_TYPE = {
      semMidia: 'Sem Mídia',
      cartao: 'Cartão',
      cartaoLeitora: 'Cartão + Leitora',
      token: 'Token',
      nuvem: 'Nuvem'
    }

    this.header = {}
    this.flows = {
      'online-purchase': 'videoconferencia',
      presential: 'presential'
    }
    this.flowsDesc = {
      videoconferencia: 'Videoconferência',
      presential: 'Presencial'
    }
    this.theme = {
      primaryColor: this.THEME_PRIMARY_COLOR,
      secondaryColor: this.THEME_SECUNDARY_COLOR
    }

    this.initWidget()

    var that = this
    $scope.$on('timer-stopped', function (event, data) {
      swal('Sua agenda expirou', 'Consulte novamente a disponibilidade.')
      that.setFlow(1)
      that.init()
    })
  }

  close () {
    var that = this
    that.$location.path('/success')
    that.initWidget()
  }

  // SETUP WIDGET
  initWidget () {
    var that = this
    var ip = ''
    that.$http.get('https://api.ipify.org/?format=json').then(function (response) {
      if (response.data && response.data.ip) ip = response.data.ip
      that.getToken(ip)
    }).catch(function (err) {
      that.$http.get('https://jsonip.com').then(function (response) {
        if (response.data && response.data.ip) ip = response.data.ip
        that.getToken(ip)
      })
    })
  }

  getToken (ip) {
    var that = this
    that.authService.getToken(ip).then(function (response) {
      if (!response.data) return
      if (response.data.customError) {
        swal({
          title: '',
          text: response.data.message,
          confirmButtonText: 'Fechar',
          allowEscapeKey: false,
          closeOnConfirm: true
        }, function () {
          that.initWidget()
        })
        return
      }

      that.selectedFlow = response.data.selectedFlow

      if (response.data.paymentGatewayToken) {
        that.paymentGatewayToken = response.data.paymentGatewayToken
      }

      if (that.selectedFlow === 'inactive') {
        that.setFlow(0)
        return
      }

      that.companyId = response.data.companyId
      that.inactiveDaysOfWeek = response.data.inactiveDaysOfWeek
      that.selectedProduct = undefined
      that.servicePointAddress = response.data.servicePointAddress
      that.brandImageUrl = response.data.brandImageUrl
      
      if (response.data.themeColor) {
        that.theme.primaryColor = response.data.themeColor
      }
      that.paymentMethods = response.data.paymentMethods

      if (response.data.paymentGateway) {
        that.paymentGateway = response.data.paymentGateway
        if (that.paymentGateway === 'GRANITO' && response.data.paymentMethod === 'CARTAO_DE_CREDITO') {
          configurePaymentMethod(that.setNonce)
          // loadIFrame('tst', response.data.paymentGatewayToken)
          loadIFrame('prd', response.data.paymentGatewayToken)
        }
      }

      that.INSTALLMENTS = []
      if (response.data.creditCardInstallments) {
        for (var i = 1; i <= response.data.creditCardInstallments; i++) {
          that.INSTALLMENTS.push({ desc: i + 'x', value: i })
        }
      } else {
        that.INSTALLMENTS.push({ desc: '1x', value: 1 })
      }

      if (response.data.products && response.data.products.length === 1) {
        that.selectedProduct = response.data.products[0]
      }

      that.$sessionStorage.putObject('h4-cert-token', {
        token: response.data.accessToken
      })

      that.init()
    })
  }

  getHelp (type) {
    var that = this
    document.querySelector('.gc-header').style.zIndex = 0

    that.modalHelp = that.$uibModal.open({
      size: 'lg',
      templateUrl: 'app/modules/main/views/modal-help/' + type + '.html',
      controller: function ($scope) {
        $scope.vm = that
      }
    })
  }

  closeModalHelp () {
    this.modalHelp.close()
    document.querySelector('.gc-header').style.zIndex = 99999
  }

  // -------------------- STEP 1 Produtos --------------------
  init () {
    var that = this
    that.$location.path('/')
    that.productStep = 1
    that.setFlow(1)
    that.getProducts()
    that.header = {}
    that.setHeaderAttendance()
    that.paying = ''
    that.spc = {
      agenda: {
        date: new Date()
      },
      hasSaleCode: 'false'
    }
    that.invoice = {
      client: {
        address: {}
      }
    }

    that.attendance
    that.showSPCForm = false
    that.products = []
    that.certValidityList = []
    that.certMediaTypeList = []
  }

  setHeaderAttendance () {
    var that = this
    if (that.selectedFlow != 'all') {
      that.header.attendance = that.flowsDesc[that.flows[that.selectedFlow]]
      that.attendance = that.flows[that.selectedFlow]
    }
    if (that.attendance === 'videoconferencia') {
      that.isOnlinePurchase = true
    }
  }

  setFlow (step) {
    this.step = step
  }

  changePaymentMethod () {
    var that = this
    if (that.invoice.paymentMethod === 'CARTAO_DE_CREDITO') {
      if (that.paymentGateway == 'GRANITO') {
        that.showGranitoCreditCardForm = true
      }
      if (that.paymentGateway == 'META_ID_PAYMENTS') {
        that.showMetaIdPaymentsCreditCardForm = true
      }
    } else {
      that.showGranitoCreditCardForm = false
      that.showMetaIdPaymentsCreditCardForm = false
    }
  }

  getProducts () {
    var that = this
    that.tablePriceService.getProducts(that.selectedFlow).then(function (res) {
      that.products = res.data
      that.setDefaultProduct(that.selectedProduct)
    }).catch(function (err) {
      alert.danger('Ops. Erro ao consultar certificados ativos.')
    })
  }

  setDefaultProduct (product) {
    var that = this
    if (product) {
      for (var i = 0; i < that.products.products.length; i++) {
        const item = that.products.products[i];
        if (item.cod === product) {
          that.setType(item.type, that.DIC_TYPE[item.type])
          that.setValidity(item.spcValidityCod, item.validityDesc)
          that.setMediaType(item.mediaType, that.DIC_MEDIA_TYPE[item.mediaType])
        }
      }
    }
  }

  setType (type, description) {
    var that = this
    that.header.type = description
    that.productStep = 2
    that.spc.type = type
    that.certValidityList = that.products.data[that.spc.type]
    that.spc.validity = undefined
    that.spc.mediaType = undefined
    that.certMediaTypeList = []
  }

  setValidity (validity, description) {
    var that = this
    that.header.price = '-'
    if (!that.selectedFlow) {
      that.header.attendance = '-'
    }
    that.header.validity = description
    that.productStep = 3
    var DIC_VALIDITY = {
      1: 'A1 - 1 Ano',
      2: 'A3 - 1 Ano',
      3: 'A3 - 2 Anos',
      4: 'A3 - 3 Anos',
      5: 'A3 - 3 Anos',
      7: 'A3 - 4 Anos'
    }
    that.spc.validity = validity
    var validityDesc = DIC_VALIDITY[that.spc.validity]
    that.certMediaTypeList = that.certValidityList.data[validityDesc]
    that.spc.mediaType = undefined
    if (that.spc.validity == 1 || that.spc.validity == 14) {
      that.setMediaType('semMidia', 'Sem Mídia')
    }
  }

  setMediaType (mediaType, description) {
    var that = this
    that.header.mediaType = description
    if (that.spc.validity == 4 && mediaType == 'semMidia') {
      swal({
        title: 'Atenção',
        text: 'Para obter este tipo de Certificado Digital é necessário já possuir uma mídia compatível (midia cartão ou token)'
      })
    }
    that.spc.mediaType = mediaType
    for (var index = 0; index < that.certMediaTypeList.data.length; index++) {
      var item = that.certMediaTypeList.data[index]
      if (item.mediaType == that.spc.mediaType) that.spc.description = item.description
    }
    that.calcPrice()

    if (that.selectedFlow === 'online-purchase') {
      that.setAttendance('videoconferencia', 'videoconferencia')
      return
    }
    if (that.selectedFlow === 'presential') {
      that.setAttendance('presential', 'Presencial')
      return
    }

    if (that.selectedFlow != 'all') {
      that.setFlow(2)
      return
    }
    that.productStep = 4
  }

  setAttendance (attendance, description) {
    var that = this
    that.attendance = attendance
    that.header.attendance = description
    if (that.attendance === 'videoconferencia') {
      that.isOnlinePurchase = true
    } else {
      that.isOnlinePurchase = false
    }
    that.setFlow(2)
    that.getAvailableTimes()
    that.dateNow = that.$moment().format('YYYY-MM-DD')
  }

  // -------------------- STEP 2 Agenda --------------------
  getAvailableTimes () {
    var that = this

    if (!that.$moment(that.spc.agenda.date).isValid()) {
      that.spc.agenda.date = new Date()
    }

    // Valida se a data estiver no passado
    if (that.$moment(that.spc.agenda.date) <= that.$moment().subtract(1, 'day')) {
      that.times = []
      return
    }

    var date = that.$moment(that.spc.agenda.date).format('MM-DD-YYYY')
    that.agendaService.getEvents(date).then(function (res) {
      that.times = res.data
    })
  }

  setTime (event, time) {
    var element = document.querySelectorAll('.gc-hour-time')
    element.forEach(function (content, item) {
      content.classList.remove('active')
    })
    var that = this
    that.spc.agenda.time = time
    var obj = event.target
    obj.classList.add('active')
  }

  // Salva ou Atualiza a Pré Agenda
  savePreAgenda () {
    var that = this

    if (!that.spc.agenda || !that.spc.agenda.time) {
      alert.warning('Antes de continuar escolha um dia e um horário para ser atendido.')
      return
    }

    that.agendaService.save(that.spc.agenda).then(function (res) {
      if (res.data.error) {
        alert.danger(res.data.message)
        that.getAvailableTimes()
        return
      } 

      that.header.date = that.$moment(that.spc.agenda.date).format('DD/MM')
      that.header.time = that.spc.agenda.time
      that.spc.agenda.id = res.data.id
      that.startedTime = true

      if (that.spc.type === 'cnpj' || that.spc.type == 'e-SIMPLES') {
        that.setFlow(4)
        that.clearSPCForm('PJ')
      } else {
        that.setFlow(3)
        that.clearSPCForm('PF')
      }
    }).catch(function (err) {
      alert.danger(err.statusText)
    })
  }

  clearSPCForm (type) {
    var that = this
    that.spc.email = ''
    that.spc.dddPhone = ''
    if (that.spc.address) {
      that.spc.address.cep = ''
      that.spc.address.number = ''
      that.spc.address.address = ''
      that.spc.address.neighborhood = ''
      that.spc.address.city = ''
      that.spc.address.state = ''
    }

    if (type === 'PJ' && that.spc.company) {
      if (that.spc.company.address) {
        that.spc.company.address.cep = ''
        that.spc.company.address.number = ''
        that.spc.company.address.address = ''
        that.spc.company.address.neighborhood = ''
        that.spc.company.address.city = ''
        that.spc.company.address.state = ''
      }
    }
  }

  // -------------------- STEP 3 e 4 --------------------
  searchBiometry (cpf) {
    var that = this
    if (cpf && cpf.length == 11) {
      that.certificateService.searchBiometry(cpf).then(function (res) {
        that.showCNH = false

        if (res.data && res.data.error) {
          swal({
            title: 'Atenção',
            text: res.data.message,
            confirmButtonText: 'Ok',
            allowEscapeKey: false,
            closeOnConfirm: true
          }, function () {
            that.init()
          })
          return
        }
        if (res.data && res.data.data === false) {
          swal({
            title: '',
            text: 'Não encontramos biometria cadastrada para o CPF informado. Deseja processeguir informando o número de registro da CNH?',
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim',
            allowEscapeKey: false,
            closeOnConfirm: true,
            closeOnCancel: false
          }, function (isConfirm) {
            if (isConfirm) {
              that.showCNH = true
            } else if (that.selectedFlow === 'online-purchase') {
              swal({
                title: '',
                text: 'Esse canal de venda é destinado para pessoas que possuam biometria cadastrada ou CNH. Caso queira continuar de outra forma, entre em contato com a certificadora',
                type: 'warning',
                confirmButtonText: 'Fechar',
                allowEscapeKey: false
              }, function () {
                that.init()
              })
            } else {
              swal({
                title: '',
                text: 'O atendimento via videoconferência é disponibilizado apenas para pessoas que possuem biometria cadastrada ou CNH. Deseja prosseguir com atendimento presencial?',
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim',
                allowEscapeKey: false,
                closeOnConfirm: true,
                closeOnCancel: true
              }, function (isConfirm) {
                if (isConfirm) {
                  that.header.attendance = 'Presencial'
                  that.attendance = 'presential'
                  that.isOnlinePurchase = false
                  return
                }
                that.init()
              })
            }
          })
        }
      }).catch(function (err) {
        alert.danger('Ops. Um erro ocorreu ao consultar biometria cadastrada.')
      })
    }
  }

  getAddress (zipCode) {
    var that = this
    if (zipCode && zipCode.length === 8) {
      that.formService.searchZipCode(zipCode).then(function (res) {
        if (res.data.erro) throw new Error()

        that.spc.address.address = res.data.logradouro
        that.spc.address.neighborhood = res.data.bairro
        that.spc.address.city = res.data.localidade
        that.spc.address.state = res.data.uf
      }).catch(function (err) {
        alert.warning("O 'CEP' digitado não foi encontrado.")
      })
    }
    that.spc.address.address = ''
    that.spc.address.neighborhood = ''
    that.spc.address.city = ''
    that.spc.address.state = ''
  }

  getCompanyAddress (zipCode) {
    var that = this
    if (zipCode && zipCode.length === 8) {
      that.formService.searchZipCode(zipCode).then(function (res) {
        if (res.data.erro) throw new Error()

        that.spc.company.address.address = res.data.logradouro
        that.spc.company.address.neighborhood = res.data.bairro
        that.spc.company.address.city = res.data.localidade
        that.spc.company.address.state = res.data.uf
      }).catch(function (err) {
        alert.warning("O 'CEP' digitado não foi encontrado.")
      })
    }
    that.spc.company.address.address = ''
    that.spc.company.address.neighborhood = ''
    that.spc.company.address.city = ''
    that.spc.company.address.state = ''
  }

  // Pesquisa cliente PF pela API do SPC
  searchPF (searchPJ) {
    var that = this
    if (that.spc.cpf && that.spc.dateBirthday) {
      that.certificateService.searchSPCRFPF(that.spc.cpf, that.spc.dateBirthday).then(function (res) {
        if (res.data.error) swal({ title: 'Atenção', text: res.data.message })
        if (res.data.name) that.disableName = true
        else that.disableName = false
        that.spc.name = res.data.name || ''
        if (searchPJ) that.searchPJ()
        else that.showSPCForm = true
      }).catch(function (err) {
        that.showSPCForm = false
        alert.danger('Ops. Um erro ocorreu ao consultar dados da Pessoa Física.')
      })
    } else {
      that.spc.name = ''
      that.showSPCForm = false
    }
  }

  // Pesquisa cliente PJ pela API do SPC
  searchPJ () {
    var that = this
    var isValidCnpj = false
    if (that.spc.cnpj) isValidCnpj = true

    if (isValidCnpj) {
      that.certificateService.searchSPCRFPJ(that.spc.cnpj, that.spc.cpf, that.spc.dateBirthday).then(function (res) {
        if (res.data.error) swal({ title: 'Atenção', text: res.data.message })
        if (!that.spc.company) that.spc.company = {}
        that.showSPCForm = true
        if (res.data.name) that.disableCompanyName = true
        else that.disableCompanyName = false
        that.spc.company.name = res.data.name || ''
      }).catch(function (err) {
        that.showSPCForm = false
        alert.danger('Ops. Um erro ocorreu ao consultar dados da Pessoa Jurídica.')
      })
    } else {
      that.showSPCForm = false
      that.spc.company.fantasyName = ''
      that.spc.company.name = ''
    }
  }

  previewConsult (isECnpj) {
    var that = this

    if (!that.spc.cpf) {
      alert.warning('Preencha o campo CPF')
      return
    }
    if (!that.spc.dateBirthday) {
      alert.warning('Preencha o campo Data de Nascimento')
      return
    }
    if (isECnpj && !that.spc.cnpj) {
      alert.warning('Preencha o campo CNPJ')
      return
    }

    that.searchPF(isECnpj)
  }

  register (form) {
    var that = this
    if (!that.formService.validateForm(form)) return

    if (that.spc.dddPhone) {
      that.spc.dddPhone = that.spc.dddPhone.toString()
      that.spc.ddd = that.spc.dddPhone.substring(0, 2)
      that.spc.phone = that.spc.dddPhone.substring(2, that.spc.dddPhone.length)
    }
    that.spc.certPrice = that.invoice.price

    var method
    if (that.attendance === 'presential') method = 'registerPresentialPurchase'
    if (that.attendance === 'videoconferencia') method = 'registerOnlinePurchase'

    that.certificateService[method](that.spc).then(function (res) {
      if (res.data) {
        if (res.data.error) {
          swal({ title: 'Atenção', text: res.data.message })
        }
        if (res.data.data && res.data.data.protocol) { that.spc.protocol = res.data.data.protocol }
        that.setFlow(5)
      }
    }).catch(function (err) {
      alert.danger('Ops. Ocorreu um erro ao realizar o cadastro.')
    })
  }

  // -------------------- STEP 5 Bill --------------------
  backToAgenda () {
    this.showSPCForm = false
    this.step = 2
  }

  // Calcula o preço do certificate
  calcPrice () {
    var that = this
    if (that.spc && that.spc.type && that.spc.validity && that.spc.mediaType) {
      that.companyService.getConfigByCertificate(that.spc.type, that.spc.validity, that.spc.mediaType).then(function (res) {
        that.invoice = {
          price: res.data.price,
          priceDesc: 'R$' + res.data.price
        }
        if (that.paymentMethods && that.paymentMethods.length === 1) {
          that.invoice.paymentMethod = that.paymentMethods[0].value
        }
        that.header.price = res.data.price
      }).catch(function (err) {
        alert.danger('Ops. Ocorreu um erro ao consultar valor do certificado.')
      })
    }
  }

  // boleto para CPF
  clearBillData () {
    this.invoice.client = {
      address: {}
    }
  }

  // boleto para CPF
  setCpfData () {
    if (!this.invoice.client) this.invoice.client = {}
    if (!this.invoice.client.address) this.invoice.client.address = {}
    this.invoice.client.cpfCnpj = this.spc.cpf
    this.invoice.client.name = this.spc.name
    this.invoice.client.email = this.spc.email
    this.invoice.client.address = {
      zipCode: this.spc.address.cep,
      street: this.spc.address.address,
      neighborhood: this.spc.address.neighborhood,
      city: this.spc.address.city,
      state: this.spc.address.state,
      number: this.spc.address.number
    }
  }

  // boleto para CNPJ
  setCnpjData () {
    if (!this.invoice.client) this.invoice.client = {}
    if (!this.invoice.client.address) this.invoice.client.address = {}
    this.invoice.client.cpfCnpj = this.spc.cnpj
    this.invoice.client.name = this.spc.company.name
    this.invoice.client.email = this.spc.email
    this.invoice.client.address = {
      zipCode: this.spc.company.address.cep,
      street: this.spc.company.address.address,
      neighborhood: this.spc.company.address.neighborhood,
      city: this.spc.company.address.city,
      state: this.spc.company.address.state,
      number: this.spc.company.address.number
    }
  }

  setClient (option) {
    var that = this
    if (option === 'cpf') {
      that.setCpfData()
      return
    }
    if (option === 'cnpj') {
      that.setCnpjData()
      return
    }
    if (option === 'OTHER') {
      that.clearBillData()
    }
  }

  getInvoiceAddress (zipCode) {
    var that = this
    if (zipCode && zipCode.length === 8) {
      that.formService.searchZipCode(zipCode).then(function (res) {
        if (res.data.erro) throw new Error()

        that.invoice.client.address.street = res.data.logradouro
        that.invoice.client.address.neighborhood = res.data.bairro
        that.invoice.client.address.city = res.data.localidade
        that.invoice.client.address.state = res.data.uf
      }).catch(function (err) {
        alert.warning("O 'CEP' digitado não foi encontrado.")
      })
    }
    that.invoice.client.address.street = ''
    that.invoice.client.address.neighborhood = ''
    that.invoice.client.address.city = ''
    that.invoice.client.address.state = ''
  }

  // Granito nonce validation
  setNonce (response) {
    var that = this
    var response = JSON.parse(response)
    if (response.nonce) {
      document.getElementById('gcGranitoNonce').value = response.nonce
      document.getElementById('gcSaveCharge').click()
    } else {
        alert.danger('Erro ao validar cartão.')
    }
  }

  encodeString(value, secret) {
    var result = '';
    var value = value.toString()
    for (var i = 0; i < value.length; i++) {
      var char = value.charCodeAt(i);
      var keyChar = secret.charCodeAt(i % secret.length);
      result += String.fromCharCode(char + keyChar);
    }
    return result;
  }

  validatePaymentMethod (form) {
    var that = this
    if (!that.formService.validateForm(form)) return
    
    if (that.showGranitoCreditCardForm) {
      sendPaymentMethodNonce()
      return
    }

    if (that.showMetaIdPaymentsCreditCardForm) {
      var encodeCard = {
        holder: that.card.holder,
        number: that.encodeString(that.card.number, that.CARD_SECRET),
        securityCode: that.encodeString(that.card.securityCode, that.CARD_SECRET),
        expirationDate: that.encodeString(that.card.expirationDate, that.CARD_SECRET)
      }

      that.paymentService.generateCreditCardToken(encodeCard).then(function (res) {
        that.invoice.ccNonce = res.data.token
        that.saveCharge()
      }).catch(function (err) {
        alert.danger('Ops. Erro ao validar cartão.')
      })
    } else {
      that.saveCharge()
    }
  }

  // Gerar boleto
  saveCharge () {
    var that = this

    var gcGranitoNonce = document.getElementById('gcGranitoNonce').value
    if (gcGranitoNonce) {
      that.invoice.ccNonce = gcGranitoNonce
    }
    that.submitDisabled = true
    that.invoice.dueDate = that.$moment().add(1, 'days')
    that.invoice.description = that.spc.description

    var method
    if (that.attendance === 'presential') method = 'generatePresentialInvoice'
    if (that.attendance === 'videoconferencia') method = 'generateVideoconferenceInvoice'

    that.paymentService[method](that.invoice, that.spc).then(function (res) {
      that.submitDisabled = false

      if (res.data && res.data.error) {
        alert.danger(res.data.message || res.data.error.message)
        return
      }

      if (that.invoice.paymentMethod === 'CARTAO_DE_CREDITO') {
        swal({ title: 'Pagamento aprovado', type: 'success' })
      }

      if (that.attendance === 'videoconferencia') {
        that.spc.protocol = res.data.protocol
      }
      that.spc.invoice = res.data.invoice
      that.spc._id = res.data._id
      that.setFlow(6)
    }).catch(function (err) {
      that.submitDisabled = false
      alert.danger('Ocorreu um erro ao gerar cobrança.')
    })
  }

  openBillingLink () {
    window.open(this.spc.invoice.link)
  }

  copyToClipBoard (value) {
    var input = document.createElement('textarea');
    input.value = value;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    parent.postMessage({ type: 'copyText', text: value }, '*');
    alert.success('Chave Pix Copiada');
  }

  // -------------------- STEP 6 Email --------------------
  loadEmailsCopy () {
    var that = this
    if (!that.spc.emailCopyList || !that.spc.emailCopyList.length) {
      that.spc.emailCopyList = []
      that.spc.emailCopyList.push({ email: that.spc.email })
      if (that.spc.invoice && that.spc.invoice.client.email && that.spc.invoice.client.email !== that.spc.email) {
        that.spc.emailCopyList.push({
          email: that.spc.invoice.client.email
        })
      }
    }
  }

  removeEmailCopy (index) {
    this.spc.emailCopyList.splice(index, 1)
  }

  addEmailCopy () {
    this.spc.emailCopyList.push({ email: angular.copy(this.email) })
    this.email = ''
  }

  sendEmail () {
    var that = this
    if (!that.spc.emailCopyList || !that.spc.emailCopyList.length) {
      swal({
        title: 'Adicione um e-mail para receber informações sobre a compra do certificado.'
      })
      return
    }

    var method
    if (that.attendance === 'presential') method = 'sendEmailPresentialPurchase'
    if (that.attendance === 'videoconferencia') method = 'sendEmailOnlinePurchase'

    that.certificateService[method](that.spc).then(function (res) {
      that.setFlow(7)
    }).catch(function (err) {
      alert.danger('Ops. Ocorreu um erro ao enviar e-mail.')
    })
  }
}

angular.module('app').controller('mainController', MainController)



//////////////////
// WEBPACK FOOTER
// ./modules/main/controllers/main.controller.js
// module id = 97
// module chunks = 0